export default "__VITE_ASSET__cd36147c__"